module.exports = __webpack_public_path__ + "img/img20.fc34e13a.svg";